import React, { useState } from 'react';
import PropTypes from 'prop-types';
// import Dashboard from '../components/Menu/Dashboard';
import { Button, FormControl, Grid, InputLabel, List, ListItem, ListItemSecondaryAction, ListItemText, ListSubheader, MenuItem, Select, TextField, Dialog, DialogActions, DialogContent, DialogTitle, Typography /*Container, Typography*/ } from '@material-ui/core';
import LoadingScreen from '../components/Complements/LoadingScreen';
import { feathersCreateData } from '../services';
import Footer from '../components/Complements/Footer';
// import { sendMobile } from '../functions/mobile';
// import moment from 'moment';
import { useEffect } from 'react';
import jsPDF from 'jspdf';



const QrGeneratesContainer = (props) => {
  const { balances, handleOpenSnack, company } = props
  // const { mac } = devices
  const [loading, setLoading] = useState(false)
  // eslint-disable-next-line
  const [showQr, setShowQr] = useState(false)
  // const [document, setDocument] = useState('')
  const [accountSelected, setAccountSelected] = useState(balances[0])
  const [name, setName] = useState('')
  const [emailMessage, setemailMessage] = useState('')
  const [qrListData, setQrListData] = useState([])
  const [mostrarDialogoN, setMostrarDialogoN] = useState(false);
  const [messageOfDialog, setMessageOfDialog] = useState('');
  // const refImage = useRef(null);
  // const classes2 = useStyles()
  const showError = (msg) => {
    setMessageOfDialog(msg);
    setMostrarDialogoN(true);
  }

  const handleGenerateQr = async () => {
  //console.log('name:', name);
  //console.log('emailMessage:', emailMessage);

  if (name.trim() === '' && emailMessage.trim() === '') {
    showError('Estimado usuario, para generar el QR es necesario completar los apartado del email y el alias.');
    return;
  }

  if (name.trim() === '') {
    showError('Estimado usuario, el campo del alias es obligatorio.');
    return;
  }

  if (emailMessage.trim() === '') {
    showError('Estimado usuario, el campo del email es obligatorio.');
    return;
  }
    if (!isValidEmail(emailMessage)) {
    showError('Estimado usuario, el email no cumple con el formato establecido.');
    return;
  }

    try {
      setLoading(true);

      // console.log('el valor de emailMessage para crear el qr es',emailMessage)
      const res = await feathersCreateData('generate-qr-for-transfers', {
        identificacionSocio: company[0].cedule,
        accountNumber: accountSelected.Codigo,
        accountType: accountSelected.Tipo,
        isCompany: true,
        name,
        emailMessage: emailMessage
      })();

      if (res.error) throw new Error(res.message);

      handleGetQRData(company[0].cedule)
      handleOpenSnack(res.message, 'success');
      setName('')
      setemailMessage('')

    } catch (error) {
      console.log({ error });
      handleOpenSnack(error.message, 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleGetQRData = async (user) => {
    const res = await feathersCreateData('generate-qr-for-transfers', {
      user,
      func: 'GET_QR_DATA'
    })();
    setQrListData(res.data)
  }

  // const handleMaskNumberAccount = (numberBeneficiary) => {
  //   if (numberBeneficiary && numberBeneficiary.length > 4) {
  //     let resultConvert = "";
  //     const [a, b, ...dataConvert] = numberBeneficiary;
  //     const inicioFin = dataConvert.length - 2;
  //     const ultimos = dataConvert.join('').slice(inicioFin, dataConvert.length);
  //     for (let y = 0; y < inicioFin; y++) {
  //       resultConvert = resultConvert.concat("X");
  //     }
  //     resultConvert = a + b + resultConvert + ultimos;
  //     return resultConvert;
  //   } else {
  //     return numberBeneficiary;
  //   }
  // }

  // const handlePrintProcess = () => {
  //   try {
  //     const { mac } = devices;
  //     if (mac !== "NAVEGADOR") {
  //       let send = {
  //         type: 'action',
  //         action: 'export_voucher',
  //         data: urlQr + `${document}`,
  //         nameFile: 'QR_PAY_' + moment().format("DDMMYYYYHHmmss"),
  //         extension: 'pdf',
  //         messageSend: 'Pago QR'
  //       }
  //       sendMobile(JSON.stringify(send))
  //     } else {
  //       handlePrint()
  //     }
  //   } catch (error) {
  //     // console.log(error)
  //   }
  // }

  // const handleGenerateQrReset = () => {
  //   setShowQr(false);
  // }

  // const handlePrint = () => {
  //   window.open(urlQr + document, '_blank');
  // }

  const handleDownloadQrDocument = (documentToPrint) => {
    const img = new Image();
    img.src = documentToPrint;

    img.onload = () => {
      const imgWidth = img.width;
      const imgHeight = img.height;

      // jsPDF usa puntos por defecto (1 pt = 1/72 pulgadas)
      // Para trabajar con píxeles, puedes usar 'px' o definir el tamaño directamente
      const doc = new jsPDF({
        orientation: imgWidth > imgHeight ? 'landscape' : 'portrait',
        unit: 'px',
        format: [imgWidth, imgHeight], // tamaño igual al de la imagen
      });

      doc.addImage(documentToPrint, 'PNG', 0, 0, imgWidth, imgHeight);

      const blob = doc.output('blob');
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, '_blank');
    };

    img.onerror = () => {
      console.error('Error loading image');
    };
  }

  const isValidEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);


  const mount = () => {
    const unmount = () => {
      handleGetQRData(company[0].cedule)
    }
    return unmount()
  }
  useEffect(mount, [])

  const renderBody = () => {
    //console.log(balances, 'balances')
    return <div style={{
      padding: "20px",
      borderRadius: "15px",
    }}>
      <Grid container alignContent='center' alignItems='center' justifyContent='center' style={{ gap: 16, margin: 'auto' }} xs={12} sm={12} md={6}>
        <div style={{ padding: 16, background: '#fff', borderRadius: 15 }}>
          <Grid item xs={12} md={12} lg={12} sm={12} style={{ padding: "20px 0", textAlign: 'center', color: '#009fae' }}>
            GENERADOR QR
          </Grid>
          <Grid container alignContent='center' alignItems='center' justifyContent='center' >
            <Grid item xs={12} md={12} lg={12} sm={12}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel id="demo-simple-select-outlined-label">Seleccione una Cuenta</InputLabel>
                <Select
                  label="Seleccione una Cuenta"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  defaultValue={accountSelected}
                  onChange={(e) => { setAccountSelected(e.target.value) }} >
                  {
                    balances.map(option => (
                      <MenuItem key={option.Codigo} value={option}>
                        <div >
                          {option.Codigo + ' - ' + option.Tipo}
                        </div>
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            <br />
            <br />
            <Grid item xs={12} md={12} lg={12} sm={12}>
              <Grid container justifyContent='center' style={{ gap: 16 }}>

                <Grid item xs={12} md={12} lg={6} xl={6} style={{ padding: "20px 0" }}>
                  <TextField
                    value={name}
                    name="name"
                    id="name"
                    autoFocus
                    label="Alias"
                    fullWidth
                    required
                    onChange={e => setName(e.target.value.toUpperCase())}
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={6} xl={6} style={{ padding: "20px 0" }}>
                  <TextField
                    value={emailMessage}
                    name="emailMessage"
                    id="emailMessage"
                    type="email"
                    label="Email"
                    fullWidth
                    required
                    onChange={e => setemailMessage(e.target.value)}
                    error={emailMessage !== "" && !isValidEmail(emailMessage)}
                    helperText={
                        emailMessage !== "" && !isValidEmail(emailMessage)
                        ? "Ingresa un correo válido"
                        : ""
                    }
                  />
                </Grid>
                <Grid style={{ width: '100%', textAlign: 'center' }}>
                  <Button variant="contained" type="submit" onClick={handleGenerateQr}
                    style={{
                      fontSize: 14,
                      borderRadius: 10,
                      height: 40
                    }}
                    color="primary"
                  // disabled={pristine}
                  >
                    Generar
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
        <div style={{ padding: 16, background: '#fff', borderRadius: 15, width: '100%' }}>
          {qrListData.length > 0 && <Grid style={{ padding: 10 }}>
            <List>
              <ListSubheader style={{ color: '#009fae' }}>Lista de QRs generados</ListSubheader>
              {
                qrListData.map(qr => (
                  <ListItem>
                    <ListItemText id={'qr' + qr.id}
                      primary={qr.name}
                      secondary={'Nro.: ' + qr.accountNumber}
                    />
                    <ListItemSecondaryAction>
                      <Button variant='outlined' onClick={() => handleDownloadQrDocument(qr.qr)}>
                        Imprimir
                      </Button>
                    </ListItemSecondaryAction>
                  </ListItem>
                ))
              }
            </List>
          </Grid>}
        </div>



      </Grid>
          <Dialog open={mostrarDialogoN} onClose={() => setMostrarDialogoN(false)}>
            <DialogTitle style={{ textAlign: 'center' }}>Advertencia</DialogTitle>
            <DialogContent>
              <Typography style={{ textAlign: 'justify' }}>
                {messageOfDialog}
              </Typography>
            </DialogContent>
          <DialogActions style={{ justifyContent: 'center' }}>
          <Button 
            onClick={() => setMostrarDialogoN(false)} 
            style={{ backgroundColor: '#c29914', color: 'white' }}
          >
            Aceptar
          </Button>
          </DialogActions>
          </Dialog>

    </div>
    
  }

  return (
    <div>
      {/* <Dashboard
        title="Dashboard"
        body={renderBody()}
        multiple={false}
      /> */}
      {renderBody()}
      <Footer />
      <LoadingScreen open={loading} />
    </div>
  );
};

QrGeneratesContainer.propTypes = {
  balances: PropTypes.array.isRequired
};

export default QrGeneratesContainer;
